<template lang="pug">
b-modal#editPromoSignup(
  ref="editPromoSignup"
  :title="$t('ui.combine.edit_promo_signup')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  size="lg"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    div.row
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.promotion_id')" disabled).mb-0
          DebounceInput(
            size="sm"
            ref="promotion_id"
            required
            type="text"
            :dirty="$v.promotion_id.$dirty"
            :error="$v.promotion_id.$error"
            v-model.trim.lazy="$v.promotion_id.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.promotion_id" :name="$t('ui.promotion_id')")
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.bonus_amount')").mb-0
          DebounceInput(
            size="sm"
            ref="bonus_amount"
            required
            type="text"
            :dirty="$v.bonus_amount.$dirty"
            :error="$v.bonus_amount.$error"
            v-model.trim.lazy="$v.bonus_amount.$model"
            :disabled="loading"
          )
          //- span.small.text-info {{ $t("message.tooltips_promo_signup") }} 
          ValidateResult(:value="$v.bonus_amount" :name="$t('ui.bonus_amount')")
    div.row
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.promotion_name')" disabled).mb-0
          DebounceInput(
            size="sm"
            ref="promotion_name"
            required
            type="text"
            :dirty="$v.promotion_name.$dirty"
            :error="$v.promotion_name.$error"
            v-model.trim.lazy="$v.promotion_name.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.promotion_name" :name="$t('ui.promotion_name')")
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.rollover')").mb-0
          DebounceInput(
            size="sm"
            ref="rollover"
            type="text"
            :dirty="$v.rollover.$dirty"
            :error="$v.rollover.$error"
            v-model.trim.lazy="$v.rollover.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.rollover" :name="$t('ui.rollover')")
    div.row
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.provider_list')" style="overflow: hidden scroll; height: 45vh;").mb-0
          .alert.alert-warning.p-1.mb-2.w-100 {{ $t("message.tooltip_promo_signup") }}
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            tr
              th.text-center.col-checkbox(colspan=2)
                .d-flex
                  .custom-checkbox.custom-control
                    input#all-provider.custom-control-input(type='checkbox' data-checkboxes="allSelected" data-checkbox-role="dad" @change="selectAll(0,$event)" v-model="allSelected[0]" :disabled="loading")
                    label.custom-control-label(for='all-provider') {{ $t('ui.all') }}
                  template(v-for="(cat, index) in providerCatList")
                    .custom-checkbox.custom-control
                      input.custom-control-input(
                        type="checkbox"
                        :id="'all-' + cat.toLowerCase()"
                        v-model="allSelected[index + 1]"
                        @change="selectAll(index + 1,$event)"
                        :disabled="loading"
                      )
                      label.custom-control-label(:for="'all-' + cat.toLowerCase()") {{ $t('ui.' + cat.toLowerCase()) }}
            tr(v-for='(p, index) in pList')
              td.text-center.col-checkbox(width="5%")
                .custom-checkbox.custom-control
                  input.custom-control-input(:id="'all-' + index" type='checkbox' v-model="provider_list" :value='p.value' :disabled="loading")
                  label.custom-control-label(:for="'all-' + index") &nbsp;
              td {{ p.text }}
        ValidateResult(:value="$v.provider_list" :name="$t('ui.provider_list')")
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.criteria')").mb-0
          VipCriteriaList(
            ref="criteria"
            size="sm"
            required
            type="array"
            :dirty="$v.criteria.$dirty"
            :error="$v.criteria.$error"
            v-model.trim.lazy="$v.criteria.$model"
            :disabled="loading"
            :hideOpt="hideOpt"
          )
          ValidateResult(:value="$v.criteria" :name="$t('ui.criteria')")
        b-form-group(:label="$t('ui.withhold_bonus')").mb-2
          div.d-flex
            label.custom-switch
              input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="$v.withhold_bonus.$model" :disabled="loading")
              span.custom-switch-indicator
        b-form-group(:label="$t('ui.withhold_amount')").mb-0
          DebounceInput(
            size="sm"
            ref="withhold_amount"
            required
            type="text"
            :dirty="$v.withhold_amount.$dirty"
            :error="$v.withhold_amount.$error"
            v-model.trim.lazy="$v.withhold_amount.$model"
            :disabled="loading || withhold_bonus"
          )
          ValidateResult(:value="$v.withhold_amount" :name="$t('ui.withhold_amount')")
        b-form-group(:label="$t('ui.max_withdraw_amount')").mb-0
          DebounceInput(
            size="sm"
            ref="max_withdraw_amount"
            required
            type="text"
            :dirty="$v.max_withdraw_amount.$dirty"
            :error="$v.max_withdraw_amount.$error"
            v-model.trim.lazy="$v.max_withdraw_amount.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.max_withdraw_amount" :name="$t('ui.max_withdraw_amount')")
        b-form-group(:label="$t('ui.start_date')").mb-0
          b-input-group(size="sm")
            date-picker.form-control-sm(
              ref="start_date"
              :config="localeDate"
              :dirty="$v.start_date.$dirty"
              :error="$v.start_date.$error"
              v-model.trim.lazy="$v.start_date.$model"
              :disabled="loading"
            )
          ValidateResult(:value="$v.start_date" :name="$t('ui.start_date')")
        b-form-group(:label="$t('ui.end_date')").mb-0
          b-input-group(size="sm")
            date-picker.form-control-sm(
              ref="end_date"
              :config="localeDate"
              :dirty="$v.end_date.$dirty"
              :error="$v.end_date.$error"
              v-model.trim.lazy="$v.end_date.$model"
              :disabled="loading"
            )
          ValidateResult(:value="$v.end_date" :name="$t('ui.end_date')")
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, decimal, integer } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import VipCriteriaList from "@/library/VipCriteriaList";
const atLeastOneProvider = (value) => value.length > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    VipCriteriaList
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      promotion_id: "",
      promotion_name: "",
      bonus_amount: "",
      rollover: "",
      criteria: "",
      withhold_bonus: true,
      withhold_amount: "",
      max_withdraw_amount: "",
      start_date: "",
      end_date: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      localeDate: {
        format: "YYYY-MM-DD",
        useCurrent: true
      },
      hideOpt: ['DEPOSIT'],
      provider_list: [],
      providerList: [],
      allSelected: {},
      pList: [],
      providerCatList: [],
      prefixMap: {}
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
  },
  validations: {
    promotion_id: {
      required,
      alphaNum,
      maxLength: maxLength(20)
    },
    promotion_name: {
      required,
      maxLength: maxLength(100)
    },
    bonus_amount: {
      required,
      decimal
    },
    rollover: {
      required,
      integer
    },
    criteria: {
      required
    },
    withhold_bonus: {
      required
    },
    withhold_amount: {
      required,
      decimal
    },
    max_withdraw_amount: {
      required,
      decimal
    },
    start_date: {
      required
    },
    end_date: {
      required
    },
    provider_list: {
      atLeastOneProvider,
      minLength: minLength(1)
    }
  },
  watch : {
    provider_list: {
      handler(newValue) {
        const val = (newValue.length === this.pList.length && this.pList.length > 0)

        const checkGroupSelected = prefix => {
          const items = this.pList.filter(item => item.category === prefix)
          return items.length > 0 && items.every(item => newValue.includes(item.value))
        }

        Object.keys(this.allSelected).forEach(k => {
          const num = Number(k)

          // master
          if (num === 0) {
            this.$set(this.allSelected, 0, val)
          }
          // others
          else {
            this.$set(this.allSelected, num, checkGroupSelected(this.providerCatList[num-1]))
          }
        })
      },
      deep: true
    },
    withhold_bonus(newVal) {
      if(newVal)
        this.withhold_amount = 0
    },
  },
  methods: {
    selectAll: function(mode, evt) {
      const prefixMap = this.prefixMap

      // If mode is 0 (master checkbox toggled), sync all individual selections
      if (mode === 0) {
        Object.keys(this.allSelected).forEach(k => {
          this.$set(this.allSelected, k, evt.target.checked)
        })

        if (!this.allSelected[0]) {
          this.provider_list = [];
          return; // Exit early if unchecking all
        }

        // Select all providers with matching prefixes
        const allPrefixes = Object.values(prefixMap);
        this.provider_list = this.pList
          .filter(item => allPrefixes.some(prefix => item.category == prefix))
          .map(item => item.value);

        return;
      }

      const checked = evt.target.checked
      this.$set(this.allSelected, mode, checked)

      // Individual group checkbox toggled
      const prefix = prefixMap[mode];
      const groupItems = this.pList.filter(item => item.category == prefix);
      const groupValues = groupItems.map(item => item.value);

      if (this.allSelected[mode]) {
        // Add group values to provider_list without duplicates
        this.provider_list = Array.from(new Set([...this.provider_list, ...groupValues]));
      } else {
        // Remove only group values
        this.provider_list = this.provider_list.filter(val => !groupValues.includes(val));
      }
    },
    removeDuplicate(arr) {
      let s = new Set(arr);
      let it = s.values();
      return Array.from(it);
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.withhold_bonus && parseFloat(this.withhold_amount) > 0) {
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.withtholdBonusAndAmountGreaterThanZero"), "error");
          return;
        }

        let url = config.promotionSignupEditUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          promotion_id: this.promotion_id,
          bonus_amount: this.bonus_amount,
          rollover: this.rollover,
          criteria: this.criteria,
          withhold_bonus: this.withhold_bonus,
          withhold_amount: this.withhold_amount,
          max_withdraw_amount: this.max_withdraw_amount,
          start_date: this.start_date,
          end_date: this.end_date,
        };

        if (this.provider_list.length != this.pList.length)
          json.provider_list = this.removeDuplicate(this.provider_list.sort()).toString();

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.editPromoSignup.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "add_promo", this.feedback.status);
                  this.$refs.editPromoSignup.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function() {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    getPList() {
      let list = this.providerList;

      let result = [];

      for(var i = 0; i < list.length; i++) {
        result.push({value: list[i].provider_code, text: list[i].provider_name, checked: false, category: list[i].category});
      }
      this.pList = result;

      this.initialProviderCheckbox();
    },
    getProviderList: function() {
      let url = config.providerMaintenanceOperatorListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        is_free: false,
        credit_type: "SEAMLESS"
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.providerList = (response.data.dt || []).filter(item => item.aggregator !== "GTA");

                this.setCategory();
                this.getPList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    setCategory() {
      // Build unique category list using Set (avoid duplicates)
      const catsSet = new Set()
      for (const item of this.providerList) {
        // add each category into Set (Set auto removes duplicates)
        catsSet.add(item.category)
      }

      // convert Set back to Array so we can use v-for easily
      this.providerCatList = Array.from(catsSet)

      // create checkbox state object
      // key 0 = master "select all" checkbox (initially false = unchecked)
      const obj = { 0: false }

      // for each category index, set initial checkbox state for that group also false
      this.providerCatList.forEach((_, i) => {
        obj[i + 1] = false  // i+1 means group number starting from 1
      })

      this.allSelected = obj

      this.prefixMap = this.providerCatList.reduce((o, v, idx) => {
        o[idx + 1] = v
        return o
      }, {})
    },
    initialProviderCheckbox() {
      if (this.item.provider_list != null) {
        var arr = this.item.provider_list.split(',');
        // Get all valid provider codes from pList
        const validProviderCodes = this.pList.map(p => p.value);

        for(var i = 0; i < arr.length; i++) {
          // Only add provider codes that exist in the current pList
          if (validProviderCodes.includes(arr[i])) {
            this.provider_list.push(arr[i]);
          }
        }
      }
      else {
        this.allSelected[0] = true;
        var arr = this.pList;
        for(var i = 0; i < arr.length; i++) {
          this.provider_list.push(arr[i].value);
        }
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.promotion_id = this.item.promotion_id;
      this.promotion_name = this.item.promotion_name;
      this.bonus_amount = this.item.bonus_amount;
      this.rollover = this.item.rollover;
      this.criteria = this.item.criteria;
      this.withhold_bonus = this.item.withhold_bonus;
      this.withhold_amount = this.item.withhold_amount;
      this.max_withdraw_amount = this.item.max_withdraw_amount;
      this.start_date = this.$moment(this.item.start_date).format('YYYY-MM-DD');
      this.end_date = this.$moment(this.item.end_date).format('YYYY-MM-DD');
      this.provider_list = [];
      this.pList = [];
      this.getProviderList();
      this.$refs.bonus_amount.$el.focus();
      this.allSelected = {};
      this.providerCatList = [];
      this.prefixMap = {};
      this.$set(this.allSelected, 0, false)
    }
  },
};
</script>
